import * as React from 'react';

import { IOfferItemProps } from '../../types';

import * as styles from './styles.css';

export const OfferItem: React.FC<IOfferItemProps> = props => {
  const { offerStartBlock, offerCardBlock, offerActualBlock, offerValuationBlock } = props;

  return (
    <tr>
      <td>{offerCardBlock}</td>
      <td>{offerStartBlock}</td>
      <td className={styles['expo-cell']}>{offerActualBlock}</td>
      <td>{offerValuationBlock}</td>
    </tr>
  );
};

OfferItem.displayName = 'OfferItem';
